import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthRoles, AuthUserType } from 'src/app/auth/auth.types';
import { AuthService } from '../../auth/auth.service';

@Directive({
  selector: '[removeIfUnauthorized]'
})
export class RemoveIfUnauthorized {
  private hasView: boolean = false;
  constructor(private container: ViewContainerRef,
    private template: TemplateRef<any>,
    private _authService: AuthService) { }

  @Input() set removeIfUnauthorized(role: AuthRoles[] | AuthUserType[]) {
    let hasAuthorization = Array.isArray(role) && (this._authService.hasRole(<AuthRoles[]>role) || this._authService.hasUserType(<AuthUserType[]>role));
    if (hasAuthorization && !this.hasView) {
      this.container.createEmbeddedView(this.template);
      this.hasView = true;
    } else if (!hasAuthorization && this.hasView) {
      this.container.clear();
      this.hasView = false;
    }
  }
}

